// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"4df8f4ac","72":"a6d05c33","202":"0794a9f9","205":"8de282ca","329":"f193ab3a","461":"68c36237","496":"4a8f4b89","506":"ff9b9cd6","529":"62051cc8","609":"8338c4a5","822":"f8fe87d5","982":"04edc579"}[chunkId] + ".chunk.js";
};